import { useCallback, useEffect, useMemo, useState } from "react";
import { isMobile } from "fe-common/utils/isMobile";
import { useSaveConversationAsCase } from "../../solverHooks/saveConversation";

export interface ShareData {
  title: string;
  text: string;
  url: string;
}

export const useGetShareData: () => () => Promise<ShareData> = () => {
  const saveCase = useSaveConversationAsCase();

  return useCallback(async () => {
    const saveCaseData = await saveCase();
    return {
      title: "Kahun case",
      text: `This patient assessment was shared with you. Click the link to view the summary of current illness and supporting insights related to your patient.\n\n${saveCaseData?.url}`,
      url: saveCaseData?.url,
    };
  }, [saveCase]);
};

export const useNativePatientShare = () => {
  const nav: any = window.navigator;

  const [loading, setLoading] = useState(true);

  const [shareData, setShareData] = useState<ShareData>(null);

  const getShareData = useGetShareData();

  const externalShareIsSupported = useMemo(
    () => !!nav && !!nav.share && isMobile.any(),
    [nav],
  );

  const loadShareData = useCallback(() => {
    getShareData()
      .then((data) => {
        setLoading(false);
        setShareData(data);
      })
      .catch((e) => console.error(e));
  }, [setLoading, getShareData, setShareData]);

  const openExternalShare = useCallback(async () => {
    // Remove url when sharing in mobile, so we will still see the text in iPhone
    return nav.share({ ...shareData, url: null });
  }, [nav, shareData]);

  useEffect(() => {
    loadShareData();
  }, [loadShareData]);

  return {
    externalShareIsSupported,
    openExternalShare,
    shareData,
    loading,
  };
};
